import { getImageUrl } from '@culture/common-helpers/cultureUtils';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import _ from 'underscore';
import LazyLoadImage from 'components/LazyLoad/Image';

import { FilePropType } from 'propTypes/common';

import { ImageFormatContext } from 'contexts/ImageFormatContext';

// eslint-disable-next-line import/no-cycle
import StyledContentBlock from 'components/StyledContent/components/StyledContentBlock';
import styles from './styles.module.scss';

const ExhibitsSlide = ({ exhibit }) => {
	const imageFormat = useContext(ImageFormatContext);
	const { file, orientation, jsonText, type } = exhibit;
	const ratioImage = (file.height / file.width) * 100;

	const imageSrc = getImageUrl(file, {
		format: imageFormat,
		params: {
			crop: 'fill',
			gravity: 'center',
			width: orientation === 'portrait' ? 442 : 884
		}
	});

	return (
		<div
			className={cx(
				styles.ExhibitsSlide,
				orientation === 'portrait' && styles.ExhibitsSlide_portrait
			)}
		>
			<div className={styles.ExhibitsSlide__Content}>
				{!_.isEmpty(jsonText) ? (
					<div className={styles.ExhibitsSlide__Text}>
						{jsonText.map((block) => (
							<StyledContentBlock
								key={block?.text?.slice(0, 15) || block?.type}
								{...block}
							/>
						))}
					</div>
				) : null}
				{type ? <div className={styles.ExhibitsSlide__Type}>{type}</div> : null}
			</div>
			{file ? (
				<div
					className={styles.ExhibitsSlide__Thumbnail}
					style={{ paddingBottom: `${ratioImage}%` }}
				>
					<LazyLoadImage
						className={styles.ExhibitsSlide__WrapImage}
						imageSrc={imageSrc}
					>
						<img
							className={styles.ExhibitsSlide__Image}
							src={imageSrc}
							alt=""
						/>
					</LazyLoadImage>
				</div>
			) : null}
		</div>
	);
};

ExhibitsSlide.propTypes = {
	exhibit: PropTypes.shape({
		file: FilePropType,
		orientation: PropTypes.oneOf(['portrait', 'landscape']),
		text: PropTypes.string,
		type: PropTypes.string,
		jsonText: PropTypes.array
	}).isRequired
};

export default ExhibitsSlide;
